import { api } from "./api";

export const dashboardApi = (params) => {
    return api.get(`/dashboard`, { params });
};

export const dashboardMonthlySalesApi = (params) => {
    return api.get(`/dashboard/sales`, { params });
};